export enum ShipmentDetailStatus {
    Status,
    InformationReceived,
    InTransit,
    InDestinationAgency,
    Assigned,
    InServicePoint,
    RetryDelivery,
    Returned,
    Delivered
}